import React, { useEffect, useState } from "react";
import { Formik, FieldArray } from "formik";
import { Alert, Backdrop, Checkbox, CircularProgress, FormControlLabel, Snackbar, Typography } from "@mui/material";
import {
  Button,
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  InputAdornment,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  styled,
} from "@mui/material";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import DynamicField from "../DynamicField";
import { FieldGroup } from "./types";
import SettingsIcon from '@mui/icons-material/Settings';
import { useBottomBar } from "../../../contexts/BottomButtonsContext";
import { REACT_APP_PORTAL_API_URL } from "../../../KeyVariables";
import { useSnackbar } from 'notistack';
import { useNavigate, useNavigation } from "react-router-dom";


const fieldGroups: FieldGroup[] = [
  {
    groupId: "satisfactie",
    title: "Nivel de satisfactie",
    fields: [
      { name: "satisfactie", label: "Nivel de satisfactie", type: "text", text: "Nivel de satisfactie", sx: 3 },
      { name: "stisfaction:1", label: "Satisfacut", type: "checkbox", sx: 3 },
      { name: "stisfaction:2", label: "Partial satisfacut", type: "checkbox", sx: 3 },
      { name: "stisfaction:3", label: "Nesatisfacut", type: "checkbox", sx: 3 },
      { name: "satisfactietext", label: "Nivel de satisfactie", type: "text", text: "În același timp, în special dacă ați bifat parțial satisfăcut sau nesatisfăcut, rugăm să indicați la care din următoarele compartimente:", sx: 12 },
      { name: "prestarea", label: "Nivel de satisfactie", type: "text", text: "Prestarea/acordarea serviciilor medicale?", sx: 4.5 },
      { name: "provision:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "provision:2", label: "NU", type: "checkbox", sx: 2.5 },
      { name: "information", label: "Nivel de satisfactie", type: "text", text: "Informare?", sx: 4.5 },
      { name: "information:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "information:2", label: "NU", type: "checkbox", sx: 6 },
      { name: "additionhealthpayments", label: "Nivel de satisfactie", type: "text", text: "Asigurarea medicală și plățile suplimentare în sănătate? ", sx: 4.5 },
      { name: "additionhealthpayments:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "additionhealthpayments:2", label: "NU", type: "checkbox", sx: 2.5 },
      { name: "congratulation", label: "Nivel de satisfactie", type: "text", text: "Facilitățile/dotările din spital?", sx: 4.5 },
      { name: "congratulation:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "congratulation:2", label: "NU", type: "checkbox", sx: 2.5 },
    ]
  },
  {
    groupId: "generale",
    title: "Date generale",
    fields: [
      { name: "firstvisitpatient", label: "Nivel de satisfactie", type: "text", text: "Vizita Dvs. a fost prima ca pacient(ă) în acest spital?", sx: 4.5 },
      { name: "firstvisitpatient:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "firstvisitpatient:2", label: "NU", type: "checkbox", sx: 5.5 },
      { name: "rangeage", label: "Nivel de satisfactie", type: "text", text: "Vârsta Dvs.?", sx: 2 },
      { name: "rangeage:1", label: "<18", type: "checkbox", sx: 1 },
      { name: "rangeage:2", label: "19-30", type: "checkbox", sx: 1 },
      { name: "rangeage:3", label: "31-40", type: "checkbox", sx: 1 },
      { name: "rangeage:4", label: "41-50", type: "checkbox", sx: 1 },
      { name: "rangeage:5", label: "51-60", type: "checkbox", sx: 1 },
      { name: "rangeage:6", label: "61-70", type: "checkbox", sx: 1 },
      { name: "rangeage:7", label: ">70", type: "checkbox", sx: 1 },
      { name: "sex", label: "Nivel de satisfactie", type: "text", text: "Genul Dvs.?", sx: 4.5 },
      { name: "sex:1", label: "M", type: "checkbox", sx: 0.8 },
      { name: "sex:2", label: "F", type: "checkbox", sx: 5.5 },
      { name: "modalitatea", label: "Care a fost modalitatea de internare în spital?", type: "select", sx: 6 },
      { name: "sectieinternat", label: "În care secție ați fost internat/ă?", type: "select", sx: 6 },
    ]
  },
  {
    groupId: "medicalservice",
    title: "Prestarea/acordarea serviciilor medicale",
    fields: [
      { name: "knowdoctornametostatusservices", label: "Nivel de satisfactie", type: "text", text: "Cunoașteți numele medicului Dvs. curant/care v-a tratat?", sx: 8 },
      { name: "knowdoctornametostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "knowdoctornametostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "knowdoctornametostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "informedtreatmenttostatusservices", label: "Nivel de satisfactie", type: "text", text: "Medicul v-a informat despre toate detaliile tratamentului și diagnosticului?", sx: 8 },
      { name: "informedtreatmenttostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "informedtreatmenttostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "informedtreatmenttostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "informedriskstostatusservices", label: "Nivel de satisfactie", type: "text", text: "Medicul v-a informat despre riscurile și consecințele tratamentului administrat, posibilele complicații?", sx: 8 },
      { name: "informedriskstostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "informedriskstostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "informedriskstostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "doctorpolitetostatusservices", label: "Nivel de satisfactie", type: "text", text: "Medicii din spital au fost cooperanți și politicoși cu DVS. ?", sx: 8 },
      { name: "doctorpolitetostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "doctorpolitetostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "doctorpolitetostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "doctorassitpolitetostatusservices", label: "Nivel de satisfactie", type: "text", text: "Asistenții medicali au fost cooperanți și politicoși cu DVS.? ", sx: 8 },
      { name: "doctorassitpolitetostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "doctorassitpolitetostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "doctorassitpolitetostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "procedureexplainedtostatusservices", label: "Nivel de satisfactie", type: "text", text: "Testele și procedurile v-au fost explicate în detalii?", sx: 8 },
      { name: "procedureexplainedtostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "procedureexplainedtostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "procedureexplainedtostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "procedureskilltostatusservices", label: "Nivel de satisfactie", type: "text", text: "Asistenții/tele medicali/e au realizat procedurile cu îndemânare?", sx: 8 },
      { name: "procedureskilltostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "procedureskilltostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "procedureskilltostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
      { name: "fastrequesttostatusservices", label: "Nivel de satisfactie", type: "text", text: "Asistenții/tele medicali/au răspuns rapid când au fost chemați?", sx: 8 },
      { name: "fastrequesttostatusservices:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "fastrequesttostatusservices:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "fastrequesttostatusservices:3", label: "Partial", type: "checkbox", sx: 1.5 },
    ]
  },
  {
    groupId: "informare",
    title: " Informare",
    fields: [
      { name: "rightspatient", label: "Nivel de satisfactie", type: "text", text: "Ați fost informat/ă cu privire la drepturile Dvs. ca pacient(ă)?", sx: 6.5 },
      { name: "rightspatient:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "rightspatient:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "responsibilitiespatient", label: "Nivel de satisfactie", type: "text", text: "Ați fost informat/ă cu privire la responsabilitățile Dvs?", sx: 6.5 },
      { name: "responsibilitiespatient:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "responsibilitiespatient:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "despre", label: "Despre care dintre următoarele instrumente propuse pentru colectarea opiniei Dvs., ați fost informat?", type: "select", sx: 6.5 },
    ]
  },
  {
    groupId: "asigmed",
    title: "Asigurarea medicală și plățile suplimentare în sănătate",
    fields: [
      { name: "insurancepatient", label: "Nivel de satisfactie", type: "text", text: "Aveți poliță de asigurare medicală?", sx: 8.5 },
      { name: "insurancepatient:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "insurancepatient:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "insurancepolicycovered", label: "Nivel de satisfactie", type: "text", text: "Polița de asigurare medicală a acoperit toate cheltuielile aferente asistenței medicale pe care ați primit-o în spital?", sx: 8.5 },
      { name: "insurancepolicycovered:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "insurancepolicycovered:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "spataliz", label: "Dacă nu, pentru ce ați plătit în perioada spitalizării Dvs. în instituția noastră", type: "select", sx: 6.5 },
      { name: "unofficialpayment", label: "Nivel de satisfactie", type: "text", text: "Ați efectuat plăți neoficiale pe durata spitalizării Dvs. în instituția noastră?", sx: 8.5 },
      { name: "unofficialpayment:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "unofficialpayment:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "serv", label: "Dacă da, pentru ce servicii?", type: "select", sx: 6.5 },
    ]
  },
  {
    groupId: "spit",
    title: "Facilitățile din spital",
    fields: [
      { name: "physicalaccess", label: "Nivel de satisfactie", type: "text", text: "Accesul fizic în spital (indicatoare, rampe, balustrade, scări comode, bănci)", sx: 8.5 },
      { name: "physicalaccess:1", label: "1", type: "checkbox", sx: 0.6 },
      { name: "physicalaccess:2", label: "2", type: "checkbox", sx: 0.6 },
      { name: "physicalaccess:3", label: "3", type: "checkbox", sx: 0.6 },
      { name: "physicalaccess:4", label: "4", type: "checkbox", sx: 0.6 },
      { name: "physicalaccess:5", label: "5", type: "checkbox", sx: 0.6 },
      { name: "patientspacewait", label: "Nivel de satisfactie", type: "text", text: "Spațiul destinat așteptării pentru pacienți", sx: 8.5 },
      { name: "patientspacewait:1", label: "1", type: "checkbox", sx: 0.6 },
      { name: "patientspacewait:2", label: "2", type: "checkbox", sx: 0.6 },
      { name: "patientspacewait:3", label: "3", type: "checkbox", sx: 0.6 },
      { name: "patientspacewait:4", label: "4", type: "checkbox", sx: 0.6 },
      { name: "patientspacewait:5", label: "5", type: "checkbox", sx: 0.6 },
      { name: "presenceindications", label: "Nivel de satisfactie", type: "text", text: "Prezența indicatoarelor, panourilor informative pentru a vă orienta în spital/a găsi cabinetul/specialistul necesar", sx: 8.5 },
      { name: "presenceindications:1", label: "1", type: "checkbox", sx: 0.6 },
      { name: "presenceindications:2", label: "2", type: "checkbox", sx: 0.6 },
      { name: "presenceindications:3", label: "3", type: "checkbox", sx: 0.6 },
      { name: "presenceindications:4", label: "4", type: "checkbox", sx: 0.6 },
      { name: "presenceindications:5", label: "5", type: "checkbox", sx: 0.6 },
      { name: "accommodationconditions", label: "Nivel de satisfactie", type: "text", text: "Condițiile de cazare în spital (numărul de paturi în salon, accesul la baie, apă caldă etc)", sx: 8.5 },
      { name: "accommodationconditions:1", label: "1", type: "checkbox", sx: 0.6 },
      { name: "accommodationconditions:2", label: "2", type: "checkbox", sx: 0.6 },
      { name: "accommodationconditions:3", label: "3", type: "checkbox", sx: 0.6 },
      { name: "accommodationconditions:4", label: "4", type: "checkbox", sx: 0.6 },
      { name: "accommodationconditions:5", label: "5", type: "checkbox", sx: 0.6 },
      { name: "hygieneconditions", label: "Nivel de satisfactie", type: "text", text: "Condițiile de igienă în spital (în sala de proceduri, secție, salon, bloc sanitar etc.) pe durata aflării Dvs", sx: 8.5 },
      { name: "hygieneconditions:1", label: "1", type: "checkbox", sx: 0.6 },
      { name: "hygieneconditions:2", label: "2", type: "checkbox", sx: 0.6 },
      { name: "hygieneconditions:3", label: "3", type: "checkbox", sx: 0.6 },
      { name: "hygieneconditions:4", label: "4", type: "checkbox", sx: 0.6 },
      { name: "hygieneconditions:5", label: "5", type: "checkbox", sx: 0.6 },
      { name: "qualityfood", label: "Nivel de satisfactie", type: "text", text: "Calitatea alimentării în spital: cantitatea porțiilor de mâncare, frecvența alimentării, temperatura alimentelor, temperatura băuturilor, volumul băuturilor", sx: 8.5 },
      { name: "qualityfood:1", label: "1", type: "checkbox", sx: 0.6 },
      { name: "qualityfood:2", label: "2", type: "checkbox", sx: 0.6 },
      { name: "qualityfood:3", label: "3", type: "checkbox", sx: 0.6 },
      { name: "qualityfood:4", label: "4", type: "checkbox", sx: 0.6 },
      { name: "qualityfood:5", label: "5", type: "checkbox", sx: 0.6 },
    ]
  },
  {
    groupId: "localitatea",
    title: "Loialitate",
    fields: [
      { name: "comeagain", label: "Nivel de satisfactie", type: "text", text: "Dacă ar fi necesar să vă adresați după servicii, ați opta/alege din nou pentru instituția noastră?", sx: 7.5 },
      { name: "comeagain:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "comeagain:2", label: "NU", type: "checkbox", sx: 0.8 },
      { name: "recommend", label: "Nivel de satisfactie", type: "text", 
        text: "Ați recomanda instituția noastră membrilor familiei, rudelor, prietenilor în caz de necesitate?", sx: 7.5 },
      { name: "recommend:1", label: "DA", type: "checkbox", sx: 0.8 },
      { name: "recommend:2", label: "NU", type: "checkbox", sx: 0.8 },
    ]
  },
  {
    groupId: "sugestii",
    title: "Sugestii",
    fields: [
      { name: "description", label: "Sugestii", type: "textarea", sx: 12 },
    ]
  }
];

const getInitialValues = () => {
  let initialValues = {};
  fieldGroups.forEach(group => {
    group.fields.forEach(field => {
      if (field.type === "checkbox") {
        initialValues[field.name] = false;
      } else {
        initialValues[field.name] = "";
      }
    });
  });
  return initialValues;
};

const validationSchema = Yup.object().shape({
  // ваша схема валидации Yup, если есть
});

const transformFormData = (values) => {
  const transformedData = {};
  for (const key in values) {
    if (values.hasOwnProperty(key) && key.includes(':')) {
      const [baseKey, index] = key.split(':');
      if (values[key]) {
        transformedData[baseKey] = parseInt(index, 10);
      }
    } else if (!key.includes(':') && values[key] !== "") {
      transformedData[key] = values[key];
    }
  }
  return transformedData;
};

const FeedbackForm = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { setElement, setElementLeft } = useBottomBar();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const {enqueueSnackbar} = useSnackbar();
  const handleCheckboxChange = (formik, baseKey, index) => {
    const checkboxes = [1, 2, 3, 4, 5];
    checkboxes.forEach(i => {
      if (i !== index) {
        formik.setFieldValue(`${baseKey}:${i}`, false);
      }
    });
    formik.setFieldValue(`${baseKey}:${index}`, true);
  };
  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    setLoading(true); // Show loading indicator
    const transformedValues = transformFormData(values);
    const formData = new FormData();

    for (const key in transformedValues) {
      if (transformedValues.hasOwnProperty(key)) {
        formData.append(key, transformedValues[key]);
      }
    }

    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${REACT_APP_PORTAL_API_URL}/portal/widget/savefeedback`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      if(response && response.status == 200){
        setShowPopup(true);
        setShowButton(false); // Hide the button
        enqueueSnackbar('Datele au fost salvate! Vă mulțumim pentru feedback!', { variant: 'success' });
        setTimeout(() => {
          navigate("/");
        }, 1000); 
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('A apărut o eroare! Vă rugăm să încercați din nou.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        handleSubmit(values);
        setSubmitting(false);
      }}
    >
      {(formik) => {
        useEffect(() => {
          const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
          };

          const handleClose = () => {
            setAnchorEl(null);
          };

          const mobileElements = (
            <>
              {showButton && (
                <>
                  <Button sx={{ px: 5 }} color="success" variant="contained" size="small" onClick={formik.handleSubmit} disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : t("Trimite")}
                  </Button>
                  <IconButton size="small" onClick={handleClick}>
                    <SettingsIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <MenuItem onClick={handleClose}>{t("Redactare avansate")}</MenuItem>
                    <MenuItem onClick={handleClose}>{t("Anuleaza")}</MenuItem>
                    <MenuItem onClick={handleClose}>{t("Patient_Report")}</MenuItem>
                  </Menu>
                </>
              )}
            </>
          );

          const defaultElements = (
            <Box display={"flex"} gap={2}>
              {showButton && (
                <>
                  <Button sx={{ px: 2 }} color="success" variant="contained" onClick={formik.handleSubmit} 
                  disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : t("Trimite")}
                  </Button>
                </>
              )}
            </Box>
          );

          setElement(isMobile ? mobileElements : defaultElements);

          return () => {
            setElement(null);
            setElementLeft(null);
          };
        }, [isMobile, t, anchorEl, formik.handleSubmit, showButton, loading]);

        return (
          <form onSubmit={formik.handleSubmit}>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <Grid container spacing={2}>
                  {fieldGroups.map((group) => (
                    <Grid item xs={group.sizes?.xs || 12} sm={group.sizes?.sm || 6} md={12} key={group.groupId}>
                      <Card>
                        <CardHeader title={t(group.title)} />
                        <Divider />
                        <CardContent>
                          <Grid container spacing={2}>
                            {group.fields.map((field) => (
                              <Grid item xs={12} md={field.sx > 0 ? field.sx : 6} key={field.name}>
                                {field.type === "text" ? (
                                  <Typography style={{ fontSize: "1.1rem", marginTop: 8 }}>
                                    {field.text}
                                  </Typography>
                                ) : field.type === "checkbox" ? (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name={field.name}
                                        checked={formik.values[field.name]}
                                        onChange={() => handleCheckboxChange(formik, field.name.split(':')[0], parseInt(field.name.split(':')[1], 10))}
                                      />
                                    }
                                    label={field.label}
                                  />
                                ) : (
                                  <DynamicField field={field} formik={formik} />
                                )}
                              </Grid>
                            ))}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} md={3}>
                {/* <PacientExpandle /> */}
              </Grid>
            </Grid>
            {/* <Snackbar open={showPopup} autoHideDuration={3000} onClose={() => setShowPopup(false)}>
              <Alert severity="success" sx={{ width: '100%' }}>
                {t("Спасибо за отзыв!")}
              </Alert>
            </Snackbar> */}
          </form>
        );
      }}
    </Formik>
  );
};

export default FeedbackForm;